/* Upside · Sober October Challenge tracker · B2C web (staging)
 *
 * Two surfaces, one data source:
 *   1. IN-CART module — injected at the top of the Rebuy Smart Cart flyout
 *      (#rebuy-cart), all widths. Read-only decorator: only adds one
 *      .upside-so-inject node, never mutates a Rebuy node, never touches the
 *      product form or Add to Cart.
 *   2. RAIL + popup — a slim lure, hidden while the cart is open; tapping it
 *      opens the milestone popup. On phones (<=600px) it spans bottom-LEFT and
 *      reserves a measured right-side gutter so the chat bubble never overlaps
 *      (no dependency on any vendor's DOM). On desktop (>=601px) it is a compact
 *      320px pill anchored bottom-LEFT, clear of the bottom-right chat bubble.
 *
 * Data: GET /apps/referral-sync/sober-october (App Proxy, Shopify-signed).
 * Rewards: spend $250 -> $25 off, $500 -> $50, $1000 -> $100. Reward is a
 * discount code in My Account, NOT auto-applied. See 1_upside-drinks/CLAUDE.md.
 *
 * UI (2026-09-30): "Sober October Challenge" banner identity — royal blue +
 * orange, chunky title, gold star-line milestones with a "you are here" marker.
 */
(function () {
  'use strict';

  var ENDPOINT = '/apps/referral-sync/sober-october';
  // Simon 2026-10-03: Rebuy Smart Cart (#rebuy-cart) today, our drawer (assets/upside-cart.js, #ud-cart)
  // after the switch. Same contract: root gets .is-visible when open, items and footer inside a flyout.
  var CART_SEL = '#rebuy-cart, #ud-cart';
  var OPEN_CLASS = 'is-visible';
  var FLYOUT_SEL = '.rebuy-cart__flyout, .ud-cart__flyout';
  var ITEM_SEL = '.rebuy-cart__flyout-item, .ud-cart__item';
  var FOOTER_SEL = '.rebuy-cart__flyout-footer, .ud-cart__footer';
  var INJECT_CLASS = 'upside-so-inject';

  function isFR() {
    var l = (document.documentElement.getAttribute('lang')
          || (window.Shopify && window.Shopify.locale) || '').toLowerCase();
    return l.indexOf('fr') === 0;
  }

  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    var s = (v % 1 === 0) ? String(v) : v.toFixed(2);
    if (isFR()) return s.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' $';
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  var STR = {
    en: {
      ttl1: 'SOBER OCTOBER', ttl2: 'CHALLENGE',
      tag1: 'The more you spend, the more you save!',
      tag2: 'Unlock rewards all month long',
      more: 'See more details',
      youSave: 'You save', whenSpend: 'When you spend',
      railName: 'Sober October Challenge',
      railSave: function (r) { return 'Save ' + r; },
      brand: '🍂 Sober October Challenge',
      spent: function (s) { return "You've spent " + s + ' this October.'; },
      unlockedShort: function (er) { return er + ' off unlocked!'; },
      topReward: function (r) { return 'Top reward unlocked: ' + r + ' off! 🎉'; },
      toReach: function (rem, nr) { return rem + ' more to reach ' + nr + ' off.'; },
      unlocksNext: function (rem, nr) { return rem + ' more unlocks ' + nr + ' off.'; },
      maxedShort: function (r) { return 'Top reward reached — ' + r + ' off.'; },
      note: 'Rewards arrive as a discount code in your account.',
      guest: 'Log in to track your October spend and unlock rewards.',
      guestH: '🍂 The Sober October Challenge is on',
      guestP: 'Spend across October and unlock up to ',
      guestTail: ' off. Log in to track your progress.',
      login: 'Log in to track', loginLong: 'Log in / create account'
    },
    fr: {
      ttl1: 'OCTOBRE SOBRE', ttl2: 'LE DÉFI',
      tag1: 'Plus vous dépensez, plus vous économisez !',
      tag2: 'Débloquez des récompenses tout le mois',
      more: 'Voir tous les détails',
      youSave: 'Vous économisez', whenSpend: 'Quand vous dépensez',
      railName: 'Défi Octobre sobre',
      railSave: function (r) { return "Jusqu'à " + r; },
      brand: '🍂 Défi Octobre sobre',
      spent: function (s) { return 'Vous avez dépensé ' + s + ' en octobre.'; },
      unlockedShort: function (er) { return er + ' de rabais débloqué !'; },
      topReward: function (r) { return 'Récompense maximale : ' + r + ' de rabais ! 🎉'; },
      toReach: function (rem, nr) { return rem + ' de plus pour atteindre ' + nr + '.'; },
      unlocksNext: function (rem, nr) { return rem + ' de plus débloque ' + nr + '.'; },
      maxedShort: function (r) { return 'Récompense maximale atteinte — ' + r + ' de rabais.'; },
      note: 'La récompense est un code de rabais dans votre compte.',
      guest: 'Connectez-vous pour suivre vos achats d’octobre et débloquer vos récompenses.',
      guestH: '🍂 Le Défi Octobre sobre est lancé',
      guestP: 'Achetez en octobre et débloquez jusqu’à ',
      guestTail: ' de rabais. Connectez-vous pour suivre votre progression.',
      login: 'Se connecter', loginLong: 'Se connecter / créer un compte'
    }
  };
  function T() { return isFR() ? STR.fr : STR.en; }

  // TEST-ONLY override (?so_as / ?so_key on the page URL) -> real data on preview.
  function endpointUrl() {
    try {
      var p = new URLSearchParams(location.search);
      var as = p.get('so_as') || p.get('as');
      var key = p.get('so_key') || p.get('test_key');
      if (as && key) return ENDPOINT + '?as=' + encodeURIComponent(as) + '&test_key=' + encodeURIComponent(key);
    } catch (e) {}
    return ENDPOINT;
  }

  var BLUE = '#1B57D2', ORANGE = '#F5811E', PEACH = '#F7DCB4';

  var CSS = [
    /* shared star-line milestones */
    '.upside-so-starline{position:relative;height:34px;margin:4px 0}',
    '.upside-so-starline.mini{height:24px;margin:2px 0}',
    '.upside-so-starbase{position:absolute;top:15px;left:0;right:0;height:4px;border-radius:999px;background:#F3E7D0}',
    '.upside-so-starline.mini .upside-so-starbase{top:10px;height:3px}',
    '.upside-so-starfill{position:absolute;top:15px;left:0;height:4px;border-radius:999px;background:linear-gradient(90deg,#F79A3C,#F5811E);transition:width .4s ease}',
    '.upside-so-starline.mini .upside-so-starfill{top:10px;height:3px}',
    '.upside-so-starrow{position:relative;display:flex;height:34px;align-items:center}',
    '.upside-so-starline.mini .upside-so-starrow{height:24px}',
    '.upside-so-starcell{flex:1;text-align:center;font-size:24px;line-height:1;color:#DCCBA3;text-shadow:0 1px 1px rgba(0,0,0,.12)}',
    '.upside-so-starcell.on{color:#FCC63F}',
    '.upside-so-starline.mini .upside-so-starcell{font-size:15px}',
    '.upside-so-marker{position:absolute;top:8px;width:16px;height:16px;margin-left:-8px;border-radius:50%;background:#fff;border:3px solid ' + BLUE + ';box-shadow:0 2px 5px rgba(27,87,210,.4);z-index:3}',
    '.upside-so-starline.mini .upside-so-marker{top:4px;width:12px;height:12px;margin-left:-6px;border-width:2px}',
    '.upside-so-amts{display:flex;margin:5px 0}',
    '.upside-so-amts>div{flex:1;text-align:center}',
    '.upside-so-amts.save>div{color:' + BLUE + ';font-weight:800;font-size:16px}',
    '.upside-so-amts.spend>div{color:' + ORANGE + ';font-weight:800;font-size:13px}',
    '.upside-so-amts.mini.save>div{font-size:12px}',
    '.upside-so-amts.mini.spend>div{font-size:11px}',
    '.upside-so-mlabel{display:flex;align-items:center;gap:8px;color:' + BLUE + ';font-weight:800;font-size:10px;letter-spacing:.12em;text-transform:uppercase;margin:2px 0}',
    '.upside-so-mlabel::before,.upside-so-mlabel::after{content:"";height:1px;background:#E2D2B4;flex:1}',
    /* ---- in-cart module ---- */
    '.upside-so-inject{margin:0 0 12px}',
    '.upside-so{border:1px solid ' + PEACH + ';border-radius:13px;padding:12px 13px 10px;',
    'background:linear-gradient(180deg,#F4FAFF,#FFFFFF);box-shadow:0 3px 12px rgba(27,47,120,.10);',
    'display:flex;flex-direction:column;gap:6px;',
    'font-family:"Montserrat",system-ui,-apple-system,"Segoe UI",Roboto,sans-serif}',
    '.upside-so-top{display:flex;align-items:center;justify-content:space-between;gap:8px}',
    '.upside-so-brand{font-weight:800;color:' + BLUE + ';font-size:12.5px;text-transform:uppercase}',
    '.upside-so-spent{font-weight:800;color:' + ORANGE + ';font-size:13px;font-variant-numeric:tabular-nums}',
    '.upside-so-spent small{color:#8aa0c0;font-weight:700}',
    '.upside-so-msg{font-size:12px;color:#4a5260;line-height:1.4}',
    '.upside-so-msg b{color:' + BLUE + ';font-variant-numeric:tabular-nums}',
    '.upside-so-msg .em{color:' + ORANGE + ';font-weight:800}',
    '.upside-so-guest{border:1px dashed #F5C98A;border-radius:13px;padding:12px 13px;',
    'background:linear-gradient(180deg,#F4FAFF,#FFFFFF);display:flex;flex-direction:column;gap:8px;align-items:flex-start;',
    'font-family:"Montserrat",system-ui,-apple-system,"Segoe UI",Roboto,sans-serif}',
    '.upside-so-guest .h{font-weight:800;color:' + BLUE + ';font-size:13px}',
    '.upside-so-guest p{font-size:12px;color:#4a5260;margin:0;line-height:1.4}',
    '.upside-so-guest p b{color:' + ORANGE + '}',
    '.upside-so-guest a{background:' + ORANGE + ';color:#fff;text-decoration:none;font-weight:800;font-size:12px;padding:8px 15px;border-radius:999px}',
    /* ---- mobile rail ---- */
    '.upside-so-rail{position:fixed;left:12px;right:var(--upside-so-gutter,92px);bottom:14px;z-index:2147482000;',
    'width:auto;display:none;flex-direction:column;gap:7px;text-align:left;',
    'background:#fff;border:1.5px solid ' + PEACH + ';border-radius:14px;padding:10px 14px 11px;',
    'box-shadow:0 6px 22px rgba(27,47,120,.20);cursor:pointer;pointer-events:auto;',
    'font-family:"Montserrat",system-ui,-apple-system,"Segoe UI",Roboto,sans-serif}',
    '.upside-so-rail-top{display:flex;align-items:baseline;justify-content:space-between;gap:8px}',
    '.upside-so-rail-name{font-size:12px;color:' + BLUE + ';font-weight:800;text-transform:uppercase}',
    '.upside-so-rail-save{font-size:11px;color:' + ORANGE + ';font-weight:800;white-space:nowrap}',
    /* Simon 2026-10-07: X so the customer can dismiss the rail (remembered in localStorage) */
    '.upside-so-rail{padding-right:34px}',
    '.upside-so-rail-x{position:absolute;top:4px;right:6px;width:26px;height:26px;border:0;background:none;color:#9fb0c6;font-size:20px;line-height:1;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center}',
    '.upside-so-rail-x:hover{color:' + BLUE + '}',
    'html.upside-so-rail-off .upside-so-rail{display:none !important}',
    '@media (max-width:600px){.upside-so-rail{display:flex}}',
    /* desktop: a compact pill anchored bottom-LEFT, clear of the bottom-right chat
       bubble, so no gutter is needed (right:auto, not the mobile full-width span) */
    '@media (min-width:601px){.upside-so-rail{display:flex;left:20px;right:auto;bottom:20px;width:320px;max-width:calc(100vw - 40px)}}',
    'html.upside-cart-open .upside-so-rail{display:none !important}',
    /* Simon 2026-10-07: never cover the mobile menu or a row of shop circles (it hid the home
       circles and the bottom of the menu). Hidden while the menu is open or circles are on screen. */
    'html.mobile-nav-open .upside-so-rail,html.upside-so-circles-in-view .upside-so-rail{display:none !important}',
    /* ---- popup ---- */
    '.upside-so-modal{position:fixed;inset:0;z-index:2147483647;display:none;align-items:flex-end;justify-content:center;padding:0;background:rgba(18,30,60,.5);pointer-events:auto}',
    '.upside-so-modal.is-open{display:flex}',
    '.upside-so-card{background:#fff;border:2px solid ' + PEACH + ';border-radius:20px 20px 0 0;max-width:460px;width:100%;padding:20px 18px 22px;',
    'box-shadow:0 -8px 40px rgba(0,0,0,.3);position:relative;max-height:88vh;overflow-y:auto;-webkit-overflow-scrolling:touch;font-family:"Montserrat",system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;animation:upsideSoUp .28s ease}',
    '@keyframes upsideSoUp{from{transform:translateY(24px);opacity:.4}to{transform:none;opacity:1}}',
    '.upside-so-x{position:absolute;top:12px;right:14px;border:0;background:none;font-size:22px;color:#9fb0c6;cursor:pointer;line-height:1;padding:2px 6px;z-index:4}',
    '.upside-so-mttl{text-align:center;line-height:.92;margin:2px 0 0;font-weight:800;letter-spacing:-.01em}',
    '.upside-so-mttl .l1{display:block;font-size:24px;color:' + BLUE + '}',
    '.upside-so-mttl .l2{display:block;font-size:24px;color:' + ORANGE + '}',
    '.upside-so-mtag1{text-align:center;color:' + BLUE + ';font-weight:800;font-size:14px;margin:8px 0 2px}',
    '.upside-so-mmore{text-align:center;margin:8px 0 6px}',
    '.upside-so-mmore a{display:inline-block;background:#FFF1E0;border:1.5px solid ' + ORANGE + ';color:#C25E00;font-weight:800;font-size:13px;padding:5px 16px;border-radius:999px;text-decoration:none}',
    '.upside-so-mmore a:hover{background:' + ORANGE + ';color:#fff}',
    '.upside-so-mtag2{text-align:center;color:#6E86A8;font-weight:700;font-size:10px;letter-spacing:.13em;text-transform:uppercase;margin:0 0 12px}',
    '.upside-so-status{background:#EAF3FF;border:1px solid #D4E6FC;border-radius:10px;padding:9px 12px;font-size:12.5px;color:#1B2433;text-align:center;margin:0 0 14px;line-height:1.4}',
    '.upside-so-status b{color:' + BLUE + '}',
    '.upside-so-status .em{color:' + ORANGE + ';font-weight:800}',
    '.upside-so-cta{display:block;position:relative;z-index:5;width:100%;box-sizing:border-box;text-align:center;background:linear-gradient(180deg,#F9A44A,' + ORANGE + ');color:#fff;text-decoration:none;',
    'font-weight:800;font-size:13px;text-transform:uppercase;letter-spacing:.04em;border:0;border-radius:999px;padding:12px 16px;margin:0 0 12px;box-shadow:0 5px 14px rgba(245,129,30,.38);cursor:pointer}',
    '.upside-so-note{font-size:11px;color:#6B7C92;text-align:center;margin:0}'
  ].join('');

  function ensureCss() {
    if (document.getElementById('upside-so-css')) return;
    var s = document.createElement('style');
    s.id = 'upside-so-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  // ---- shared data ----
  var data = null;
  var fetchStarted = false;
  var railEl = null;
  var modalEl = null;
  var gutterWired = false;

  function DEFAULT_TIERS() {
    return [{ atCents: 25000, rewardCents: 2500 }, { atCents: 50000, rewardCents: 5000 }, { atCents: 100000, rewardCents: 10000 }];
  }
  function tiersOf() { return (data && data.tiers && data.tiers.length) ? data.tiers : DEFAULT_TIERS(); }
  function maxRewardCents() { return tiersOf().reduce(function (m, t) { return Math.max(m, Number(t.rewardCents) || 0); }, 0); }

  // Star positions, which stars are lit, fill %, and the "you are here" marker %.
  function milestone() {
    var tiers = tiersOf();
    var N = tiers.length;
    var spent = (data && !data.guest) ? Number(data.spentCents) || 0 : 0;
    var pos = tiers.map(function (_, i) { return ((i + 0.5) / N) * 100; });
    var reached = 0;
    for (var i = 0; i < N; i++) if (spent >= tiers[i].atCents) reached++;
    var maxed = reached >= N;
    var fill, marker = null;
    if (maxed) { fill = pos[N - 1]; }
    else {
      var lowerT = reached === 0 ? 0 : tiers[reached - 1].atCents;
      var nextT = tiers[reached].atCents;
      var segFrac = nextT > lowerT ? Math.max(0, Math.min(1, (spent - lowerT) / (nextT - lowerT))) : 0;
      var posStart = reached === 0 ? 0 : pos[reached - 1];
      marker = posStart + segFrac * (pos[reached] - posStart);
      fill = marker;
    }
    return { tiers: tiers, pos: pos, reached: reached, maxed: maxed, fill: fill, marker: marker };
  }

  function starLineHtml(m, mini) {
    var starsRow = m.tiers.map(function (t, i) {
      return '<span class="upside-so-starcell' + (i < m.reached ? ' on' : '') + '">★</span>';
    }).join('');
    var markerHtml = (!(data && data.guest) && !m.maxed && m.marker != null)
      ? '<span class="upside-so-marker" style="left:' + m.marker + '%"></span>' : '';
    return '<div class="upside-so-starline' + (mini ? ' mini' : '') + '">' +
      '<div class="upside-so-starbase"></div>' +
      '<div class="upside-so-starfill" style="width:' + m.fill + '%"></div>' +
      '<div class="upside-so-starrow">' + starsRow + '</div>' +
      markerHtml +
      '</div>';
  }
  function amtsRowHtml(m, kind, mini) {
    var cells = m.tiers.map(function (t) {
      // Simon 2026-10-02: "$25 off" is clearer than "$25" on the reward row
      return '<div>' + (kind === 'save' ? money(t.rewardCents) + (isFR() ? ' de rabais' : ' off') : money(t.atCents)) + '</div>';
    }).join('');
    return '<div class="upside-so-amts ' + kind + (mini ? ' mini' : '') + '">' + cells + '</div>';
  }

  function startFetch() {
    if (fetchStarted) return;
    fetchStarted = true;
    fetch(endpointUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (r.status === 204) return { guest: true }; if (!r.ok) return { guest: true }; return r.json(); })
      .then(function (d) { data = d || { guest: true }; paintAll(); })
      .catch(function () { data = { guest: true }; paintAll(); });
  }
  function paintAll() {
    renderRail();
    if (modalEl) { modalEl.remove(); modalEl = null; openModal(); }
    runCart();
  }

  // ================= MOBILE RAIL + POPUP =================
  function findLauncher() {
    var vw = window.innerWidth, vh = window.innerHeight;
    var nodes = document.querySelectorAll(
      '[id*="gorgias" i],[class*="gorgias" i],[id*="chat" i],[class*="chat" i],[aria-label*="chat" i],iframe');
    var best = null, bestArea = 0;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('.upside-so-rail') || el.closest('.upside-so-modal') || el.closest('.' + INJECT_CLASS)) continue;
      var cs;
      try { cs = getComputedStyle(el); } catch (e) { continue; }
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity || '1') === 0) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 24 || r.height < 24 || r.width > 140 || r.height > 140) continue;
      if (r.bottom < vh * 0.5) continue;
      if ((vw - r.right) > 120) continue;
      if ((vh - r.bottom) > 170) continue;
      var area = r.width * r.height;
      if (area > bestArea) { bestArea = area; best = r; }
    }
    return best;
  }
  function syncGutter() {
    var r = findLauncher();
    if (!r) return;
    var gutter = Math.max(60, Math.min(160, Math.round((window.innerWidth - r.left) + 8)));
    document.documentElement.style.setProperty('--upside-so-gutter', gutter + 'px');
  }
  // Toggles html.upside-so-circles-in-view while any .ud-circles row is visible.
  var circlesWired = false;
  function wireCircles() {
    if (circlesWired || !window.IntersectionObserver) return;
    var rows = document.querySelectorAll('.ud-circles');
    if (!rows.length) return;
    circlesWired = true;
    var seen = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
      document.documentElement.classList.toggle('upside-so-circles-in-view', seen.size > 0);
    });
    rows.forEach(function (r) { io.observe(r); });
  }

  function wireGutter() {
    wireCircles();
    if (gutterWired) return;
    gutterWired = true;
    window.addEventListener('resize', function () { syncGutter(); }, { passive: true });
    [400, 1200, 2500, 4500].forEach(function (t) { setTimeout(syncGutter, t); });
  }

  var RAIL_OFF_KEY = 'upside-so-rail-off';
  function railDismissed() { try { return localStorage.getItem(RAIL_OFF_KEY) === '1'; } catch (e) { return false; } }
  function dismissRail(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    try { localStorage.setItem(RAIL_OFF_KEY, '1'); } catch (err) {}
    document.documentElement.classList.add('upside-so-rail-off');
  }

  function renderRail() {
    // Simon 2026-10-09: rail OFF, the Advent calendar presale bar takes that spot (bigger, sells more).
    // The in-cart tracker and the account card stay. Delete this return to bring the rail back.
    return;
    ensureCss();
    if (railDismissed()) document.documentElement.classList.add('upside-so-rail-off');
    if (!railEl) {
      // div role=button (not <button>) so the close X can live inside it
      railEl = document.createElement('div');
      railEl.setAttribute('role', 'button');
      railEl.tabIndex = 0;
      railEl.id = 'upside-so-rail';
      railEl.className = 'upside-so-rail';
      railEl.setAttribute('aria-label', T().railName);
      railEl.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.upside-so-rail-x')) return dismissRail(e);
        openModal();
      });
      railEl.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(); } });
      (document.body || document.documentElement).appendChild(railEl);
    }
    var m = milestone();
    railEl.innerHTML =
      '<button type="button" class="upside-so-rail-x" aria-label="' + (isFR() ? 'Fermer' : 'Close') + '">×</button>' +
      '<div class="upside-so-rail-top"><span class="upside-so-rail-name">' + T().railName + '</span>' +
      '<span class="upside-so-rail-save">' + T().railSave(money(maxRewardCents())) + '</span></div>' +
      starLineHtml(m, true);
    wireGutter();
    if (window.requestAnimationFrame) requestAnimationFrame(syncGutter); else syncGutter();
  }

  function statusHtml() {
    var t = T();
    if (!data || data.guest) return t.guest;
    var base = t.spent(money(data.spentCents)) + ' ';
    if (data.maxed) return base + '<span class="em">' + t.topReward(money(data.earnedRewardCents)) + '</span>';
    if (data.earnedRewardCents) return base + '<span class="em">' + t.unlockedShort(money(data.earnedRewardCents)) + '</span> ' + t.toReach(money(data.remainingCents), money(data.nextRewardCents));
    return base + t.unlocksNext(money(data.remainingCents), money(data.nextRewardCents));
  }

  function buildModal() {
    var t = T();
    var m = milestone();
    var overlay = document.createElement('div');
    overlay.className = 'upside-so-modal';
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    var guestCta = (data && data.guest) ? '<a class="upside-so-cta" href="/account/login">' + t.login + '</a>' : '';
    overlay.innerHTML =
      '<div class="upside-so-card" role="dialog" aria-modal="true">' +
        '<button class="upside-so-x" type="button" aria-label="Close">×</button>' +
        '<div class="upside-so-mttl"><span class="l1">' + t.ttl1 + '</span><span class="l2">' + t.ttl2 + '</span></div>' +
        '<p class="upside-so-mtag1">' + t.tag1 + '</p>' +
        '<p class="upside-so-mmore"><a href="' + (isFR() ? '/fr' : '') + '/pages/sober-october-challenge">' + t.more + ' &rarr;</a></p>' +
        '<p class="upside-so-mtag2">' + t.tag2 + '</p>' +
        '<div class="upside-so-status">' + statusHtml() + '</div>' +
        guestCta +
        '<div class="upside-so-mlabel">' + t.youSave + '</div>' +
        amtsRowHtml(m, 'save', false) +
        starLineHtml(m, false) +
        amtsRowHtml(m, 'spend', false) +
        '<div class="upside-so-mlabel">' + t.whenSpend + '</div>' +
        '<p class="upside-so-note">' + t.note + '</p>' +
      '</div>';
    overlay.querySelector('.upside-so-x').addEventListener('click', closeModal);
    return overlay;
  }
  function openModal() {
    ensureCss();
    if (modalEl) modalEl.remove();
    modalEl = buildModal();
    (document.body || document.documentElement).appendChild(modalEl);
    void modalEl.offsetWidth;
    modalEl.classList.add('is-open');
    document.addEventListener('keydown', onKey);
  }
  function closeModal() {
    if (modalEl) { modalEl.classList.remove('is-open'); modalEl.remove(); modalEl = null; }
    document.removeEventListener('keydown', onKey);
  }
  function onKey(e) { if (e.key === 'Escape') closeModal(); }

  // ================= IN-CART MODULE =================
  function inCartMsg() {
    var t = T();
    if (!data) return '';
    if (data.maxed) return '<span class="em">' + t.maxedShort(money(data.earnedRewardCents)) + '</span>';
    if (data.earnedRewardCents) return '<span class="em">' + t.unlockedShort(money(data.earnedRewardCents)) + '</span> ' + t.toReach('<b>' + money(data.remainingCents) + '</b>', money(data.nextRewardCents));
    return t.unlocksNext('<b>' + money(data.remainingCents) + '</b>', money(data.nextRewardCents));
  }
  function inCartHtml() {
    var t = T();
    if (data && data.guest) {
      return '<div class="upside-so-guest">' +
        '<div class="h">' + t.guestH + '</div>' +
        '<a href="/account/login">' + t.loginLong + '</a>' +
        '<p>' + t.guestP + '<b>' + money(maxRewardCents()) + '</b>' + t.guestTail + '</p>' +
        '</div>';
    }
    var m = milestone();
    var spent = data ? (Number(data.spentCents) || 0) : 0;
    var target = data ? (Number(data.targetCents) || 0) : m.tiers[0].atCents;
    return '<div class="upside-so">' +
      '<div class="upside-so-top">' +
        '<span class="upside-so-brand">' + t.brand + '</span>' +
        '<span class="upside-so-spent">' + money(spent) + '<small> / ' + money(target) + '</small></span>' +
      '</div>' +
      amtsRowHtml(m, 'save', true) +
      starLineHtml(m, true) +
      amtsRowHtml(m, 'spend', true) +
      (data ? '<div class="upside-so-msg">' + inCartMsg() + '</div>' : '') +
    '</div>';
  }
  function insertModule(cart, node) {
    var firstItem = cart.querySelector(ITEM_SEL);
    if (firstItem && firstItem.parentNode) { firstItem.parentNode.insertBefore(node, firstItem); return; }
    var footer = cart.querySelector(FOOTER_SEL);
    if (footer && footer.parentNode) { footer.parentNode.insertBefore(node, footer); return; }
    var flyout = cart.querySelector(FLYOUT_SEL) || cart;
    flyout.insertBefore(node, flyout.firstChild);
  }
  function decorate(cart) {
    ensureCss();
    if (data == null) startFetch();
    var html = inCartHtml();
    // Idempotent: when the module is already present and its content hasn't
    // changed, do NOTHING. Rebuilding on every cart mutation used to destroy and
    // recreate the login link under the user's finger, which made the tap
    // intermittently need a second press. Leaving the node untouched keeps the
    // link stable so it fires on the first click every time.
    var existing = cart.querySelector('.' + INJECT_CLASS);
    if (existing) {
      if (existing.innerHTML !== html) existing.innerHTML = html;
      return;
    }
    var wrap = document.createElement('div');
    wrap.className = INJECT_CLASS;
    wrap.innerHTML = html;
    insertModule(cart, wrap);
  }

  var observer = null, pending = false;
  function runCart() {
    var cart = null;
    document.querySelectorAll(CART_SEL).forEach(function (c) { if (!cart && c.classList.contains(OPEN_CLASS)) cart = c; });
    if (!cart) return;
    if (observer) observer.disconnect();
    try { decorate(cart); } catch (e) {}
    if (observer) observer.observe(cart, { childList: true, subtree: true, characterData: true });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; runCart(); }, 120);
  }
  function attachCart(cart) {
    observer = new MutationObserver(schedule);
    observer.observe(cart, { childList: true, subtree: true, characterData: true });
    new MutationObserver(schedule).observe(cart, { attributes: true, attributeFilter: ['class'] });
    schedule();
  }

  // ================= INIT =================
  function init() {
    renderRail();
    startFetch();
    var el = document.querySelector(CART_SEL);
    if (el) { attachCart(el); }
    else {
      var bo = new MutationObserver(function () {
        var c = document.querySelector(CART_SEL);
        if (c) { bo.disconnect(); attachCart(c); }
      });
      bo.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
